import gql from 'graphql-tag';

export default gql(`{
  Services {
    uuid
    name
    suppliersCount
    demandersCount
  }
}`);



// WEBPACK FOOTER //
// ./src/api/query/Services.js